















import { Component, Vue, Watch } from 'vue-property-decorator';
import { DxTabs } from 'devextreme-vue';

@Component({
  components: {
    DxTabs,
  },
})
export default class BookKeepingNavigation extends Vue {
  navIndex: number = 0;
  initialised: boolean = false;

  mounted() {
    switch (this.$route.name) {
      case 'projectstoprogressoverview':
        this.navIndex = 0;
        break;
      case 'progressstatementfollowup':
        this.navIndex = 1;
        break;
    }

    setTimeout(() => {
      this.initialised = true;
    }, 150);
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-book', text: 'Op te maken vorderstaten' },
      { icon: 'fas fa-tasks', text: 'Opvolging vorderstaten' },
    ];
  }

  @Watch('navIndex')
  private onNavIndexChanged(value: number, oldValue: number) {
    if (value === -1) {
      setTimeout(() => {
        this.navIndex = 0;
      }, 150);
    } else {
      if (this.initialised) {
        switch (value) {
          case 0:
            this.$router.push({ path: `/projectstoprogressoverview` });
            break;
          case 1:
            this.$router.push({ path: `/progressstatementfollowup` });
            break;
        }
      }
    }
  }
}
